import { CaseFormFieldEntity } from './case-form-field.entity';

/**
 * Case Form Detail entity
 * Extended information about a case form including all fields
 */
export class CaseFormDetailEntity {
  public id!: string;
  public name!: string;
  public displayName!: string;
  public description!: string;
  public caseTypeId!: string;
  public caseTypeName!: string;
  public status!: number;
  public statusName!: 'Draft' | 'Published' | 'Archived';
  public versionId!: string;
  public versionNumber!: number;
  public fields!: CaseFormFieldEntity[];
  public createdAt!: Date;
  public updatedAt!: Date;
  public createdBy!: string;
  public updatedBy!: string;
}
